<script>
import HallForm from "@/views/menu/hall/hallForm";
import Component, { mixins } from "vue-class-component";
import { toastService } from "@/services/toastService.js";

@Component({
  inject: {
    hallService: "hallService",
  },
})
export default class HallNew extends mixins(HallForm) {
  formId = "new-hall-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save,
      },
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
        await this.hallService.create({
        idEvent: this.model.idEvent,
        code: this.model.code,
        localizations: this.model.localizations,
      });
      this.$router.push("/hall/list");
      toastService.success(this.translations.success.hall_create);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.halls_new;
  }

  afterCreate () {
    this.model = {
      code: null,
      event: null,
      localizations: [],
    };
    this.isReady = true;
  }
}
</script>
